import styles from './HomePage.module.scss';
import { CategoryCardDetail, Carousel, PageTitle } from '../../components';
import { HOME_PAGE_CONSTANTS } from '../../constants';
import { useRef, useEffect } from 'react';

const HomePage = (props) => {
  const categoriesData = props.details;
  const homePageRef = useRef(null);
  useEffect(()=>{
    homePageRef.current.scrollIntoView({block: 'start'});
  });

  return (
    <div ref={homePageRef} className={styles.homePageWrapper}>
      <PageTitle label={HOME_PAGE_CONSTANTS.HOME} />
      <Carousel />
      <div className={styles.categoryCardWrapper}>
        {categoriesData.map((data) => {
          const imageURL = require(`../../assets/images/${data.image}`);
          return (
            <CategoryCardDetail
              key={data.name}
              title={data.name}
              image={imageURL}
              description={data.description}
              date={data.date}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HomePage;
